package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.RequestInit

object PasswordChangeApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun changePassword(userId: String, password: String, oldPassword: String = ""): All? {
        if (userId.isBlank() || password.isBlank()) return null
        val raw = runCatching {
            val response = window.fetch(
                "${LumaticaApiSettings.getBaseUrl()}/api/userverwaltung/password-change-json",
                RequestInit(
                    method = "POST",
                    headers = LumaticaApiManager.auditHeaders("application/json"),
                    body = json.encodeToString(
                        buildJsonObject {
                            put("userId", userId)
                            put("password", password)
                            put("oldPassword", oldPassword)
                        }
                    )
                )
            ).await()
            response.text().await()
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return null
        return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
    }

    suspend fun changeCurrentLoginPassword(password: String, oldPassword: String = ""): All? =
        changePassword(LoginService.getId(), password, oldPassword)
}
